export enum ButtonVariant {
    primary = 'primary',
    secondary = 'secondary',
    disabled = 'disabled',
    primaryOutlined = 'primaryOutlined',
    secondaryOutlined = 'secondaryOutlined',
    disabledOutlined = 'disabledOutlined',
    primaryRound = 'primaryRound',
    secondaryRound = 'secondaryRound',
    disabledRound = 'disabledRound',
    grayRound = 'grayRound',
    primaryBigRound = 'primaryBigRound',
    secondaryBigRound = 'secondaryBigRound',
    transparentBigRound = 'transparentBigRound',
}

export enum ModalSizes {
    small = 'small',
    medium = 'medium',
    large = 'large',
}

export enum DLPState {
    dlp_on = 'dlp_on',
    dlp_optional = 'dlp_optional',
    dlp_off = 'dlp_off',
}

export enum BadgeVariant {
    info = 'info',
    success = 'success',
    warning = 'warning',
    danger = 'danger',
}

export enum ModelsTabName {
    chatModels = 'chatModels',
    embeddingModels = 'embeddingModels',
}

export enum PromptFunctionsTabName {
    promptFunctions = 'promptfunctions',
    openApi = 'openapi',
    mcp = 'mcp',
}

export enum OpenApiTabName {
    configs = 'configs',
    testing = 'testing',
}

export enum McpTabName {
    configs = 'configs',
    testing = 'testing',
}

export enum SettingsTabName {
    general = 'general',
    dataprotection = 'dataprotection',
    instanceSettings = 'instanceSettings',
    system = 'system',
    advancedSettings = 'advancedSettings',
}

export enum ChatMessageRole {
    assistant = 'assistant',
    user = 'user',
}

export enum AssistantTabs {
    main = 'main',
    knowledgebase = 'knowledgebase',
    description = 'description',
    model = 'model',
    connector = 'connector',
    dataProtection = 'dataProtection',
    functions = 'functions',
    groups = 'groups',
}

export enum DocumentProcessingType {
    none = 'none',
    local = 'local',
    openai = 'openai',
}

export enum LogType {
    Audit = 'audit',
    Auth = 'auth',
    Dlp = 'dlp',
    Scim = 'scim',
    System = 'system',
    Security = 'security',
}
